(ns common.resource.query.product
  (:require [cljs-bean.core :refer [->clj ->js]]
            [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn- get-sort-param [^js sort-model]
  (when-let [^js sort (first sort-model)]
    (let [sort-column (.-field sort)
          sort-order (.-sort sort)
          sort-kind (if (contains? #{"sku" "updated-at"} sort-column)
                      "meta"
                      "field")]
      [{"kind" sort-kind
        sort-kind sort-column
        "order" sort-order}])))

(defn- get-filter-param [^js filter-model]
  (when-let [filter (.-items filter-model)]
    (->clj filter)))

(defn get-request-params
  [{:keys [^js pagination-model ^js sort-model ^js filter-model]} ^js ctx]
  (let [sort (get-sort-param sort-model)
        filter (get-filter-param filter-model)]
    (cond-> {:version 1
             :limit (.-pageSize pagination-model)
             :offset (* 10 (dec (.-pageParam ctx)))}
      sort (assoc :sort sort)
      filter (assoc :filter filter))))

(defn products-query
  [{:keys [advertiser-id]}
   {:keys [^js sort-model ^js filter-model ^js pagination-model] :as table-models}]
  #js {:queryKey #js ["products"
                      advertiser-id
                      sort-model
                      filter-model
                      (some-> pagination-model .-pageSize)]
       :queryFn (fn [^js ctx]
                  (qhttp/post (qhttp/render :api/product-search {:advertiser-id advertiser-id})
                              {:body (get-request-params table-models ctx)}))
       :initialPageParam 1
       :getNextPageParam (fn [_ pages]
                           (inc (count pages)))
       :enabled (boolean advertiser-id)})

(defn- prepare-product-payload [product-data]
  (doto (js/FormData.)
    (.append "_json" (js/JSON.stringify product-data))))

(defn create-product-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["create-product" advertiser-id]
       :mutationFn (fn [product-data]
                     (rf/dispatch [:loader/open])
                     (let [form-data (prepare-product-payload product-data)]
                       (qhttp/post (qhttp/render :api/product-store-products
                                                 {:advertiser-id advertiser-id}
                                                 {:create true})
                                   {:body form-data
                                    :format :form-data})))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["products" advertiser-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Product"
                                      :type :success
                                      :message "Successfully created product"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Product"
                                 :type :error
                                 :message "Failed to create product"
                                 :response (->clj response)}]))})

(defn update-product-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["update-product" advertiser-id]
       :mutationFn (fn [product-data]
                     (rf/dispatch [:loader/open])
                     (let [form-data (prepare-product-payload product-data)]
                       (qhttp/post (qhttp/render :api/product-store-products
                                                 {:advertiser-id advertiser-id}
                                                 {:create false})
                                   {:body form-data
                                    :format :form-data})))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["products" advertiser-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Product"
                                      :type :success
                                      :message "Successfully updated product"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Product"
                                 :type :error
                                 :message "Failed to update product"
                                 :response (->clj response)}]))})

(defn delete-product-mutation [{:keys [advertiser-id product-id]}]
  #js {:mutationKey #js ["delete-product" product-id]
       :mutationFn (fn []
                     (rf/dispatch [:loader/open])
                     (qhttp/delete (qhttp/render :api/product
                                                 {:product-id product-id})))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["products" advertiser-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "Product"
                                      :type :success
                                      :message "Successfully deleted product"}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "Product"
                                 :type :error
                                 :message "Failed to delete product"
                                 :response (->clj response)}]))})

(defn delete-all-products-mutation [{:keys [advertiser-id]}]
  #js {:mutationKey #js ["delete-all-products" advertiser-id]
       :mutationFn (fn []
                     (rf/dispatch [:loader/open])
                     (qhttp/delete (qhttp/render :api/product-store-products
                                                 {:advertiser-id advertiser-id})))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [^js _response]
                    (js/setTimeout
                     (fn []
                       (invalidate-queries {:queryKey ["product-store" advertiser-id]})
                       (invalidate-queries {:queryKey ["products" advertiser-id]})
                       (rf/dispatch [:response-handler/handle-response
                                     {:entity-name "products"
                                      :type :success
                                      :message "Successfully deleted all products."}]))
                     1000))
       :onError (fn [^js response]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "products"
                                 :type :error
                                 :message "Failed to delete all products."
                                 :response (->clj response)}]))})
